export default class LeaderIdInfoCrud {
	constructor (init = {}) {
		this.leader_id = init.hasOwnProperty('leader_id') ? init.leader_id : null
		this.leader_refresh_token = init.hasOwnProperty('leader_refresh_token') ? init.leader_refresh_token : null
		this.leader_access_token = init.hasOwnProperty('leader_access_token') ? init.leader_access_token : null
		this.leader_expires_in = init.hasOwnProperty('leader_expires_in') ? init.leader_expires_in : null
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/LeaderIdInfoCrud.class.js